import { useNavigate } from "react-router-dom";

import ArrowLeftIcon from "@/assets/arrow-left.svg?react";
import ArrowRightIcon from "@/assets/arrow-right.svg?react";
import { Button } from "@/components/ui/button";
import { useLessonStore } from "@/store/lesson";
import { useTrainingStore } from "@/store/training";

export function AcademyTrainingLesson() {
	const { lesson } = useLessonStore();
	const { training } = useTrainingStore();
	const navigate = useNavigate();

	function getUuid(link: string) {
		const url = new URL(link);
		const uuid = url.pathname.split("/")[1];
		return uuid;
	}

	function handleNextLesson() {
		if (lesson && training) {
			const currentModuleIndex = training.modules.findIndex(
				(module) => module.id === lesson.module_id,
			);

			const currentModule = training.modules[currentModuleIndex];

			if (currentModule) {
				const currentLessonIndex = currentModule.lessons.findIndex(
					(l) => l.id === lesson.id,
				);

				if (currentLessonIndex < currentModule.lessons.length - 1) {
					// Next lesson in the same module
					const nextLesson = currentModule.lessons[currentLessonIndex + 1];
					navigate(
						`/academy/${training.id}/${currentModule.id}/${nextLesson.id}`,
					);
				} else if (currentModuleIndex < training.modules.length - 1) {
					// First lesson of the next module
					const nextModule = training.modules[currentModuleIndex + 1];
					const nextLesson = nextModule.lessons[0];
					navigate(`/academy/${training.id}/${nextModule.id}/${nextLesson.id}`);
				}
			}
		}
	}

	function handlePreviousLesson() {
		if (lesson && training) {
			const currentModuleIndex = training.modules.findIndex(
				(module) => module.id === lesson.module_id,
			);
			const currentModule = training.modules[currentModuleIndex];

			if (currentModule) {
				const currentLessonIndex = currentModule.lessons.findIndex(
					(l) => l.id === lesson.id,
				);

				console.log(currentLessonIndex);

				if (currentLessonIndex > 0) {
					// Previous lesson in the same module
					const previousLesson = currentModule.lessons[currentLessonIndex - 1];
					navigate(
						`/academy/${training.id}/${currentModule.id}/${previousLesson.id}`,
					);
				} else if (currentModuleIndex > 0) {
					// Last lesson of the previous module
					const previousModule = training.modules[currentModuleIndex - 1];
					const previousLesson =
						previousModule.lessons[previousModule.lessons.length - 1];
					navigate(
						`/academy/${training.id}/${previousModule.id}/${previousLesson.id}`,
					);
				}
			}
		}
	}

	function canNavigateToPreviousLesson() {
		if (lesson && training) {
			const currentModuleIndex = training.modules.findIndex(
				(module) => module.id === lesson.module_id,
			);
			const currentModule = training.modules[currentModuleIndex];

			if (currentModule) {
				const currentLessonIndex = currentModule.lessons.findIndex(
					(l) => l.id === lesson.id,
				);

				return currentLessonIndex > 0 || currentModuleIndex > 0;
			}
		}

		return false;
	}

	function canNavigateToNextLesson() {
		if (lesson && training) {
			const currentModuleIndex = training.modules.findIndex(
				(module) => module.id === lesson.module_id,
			);
			const currentModule = training.modules[currentModuleIndex];

			if (currentModule) {
				const currentLessonIndex = currentModule.lessons.findIndex(
					(l) => l.id === lesson.id,
				);

				return (
					currentLessonIndex < currentModule.lessons.length - 1 ||
					currentModuleIndex < training.modules.length - 1
				);
			}
		}

		return false;
	}

	return (
		<>
			{lesson?.link && (
				<div className="flex h-48 w-full items-center justify-center rounded-xl bg-neutral-100 bg-opacity-60 md:h-full">
					{lesson?.link && (
						<div className="relative w-full md:px-40">
							<div
								className="relative w-full overflow-hidden"
								style={{ paddingBottom: "56.25%" }}
							>
								<iframe
									id={`panda-${getUuid(lesson?.link)}`}
									src={lesson?.link}
									className="absolute left-0 top-0 h-full w-full"
									allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture"
									allowFullScreen={true}
								/>
							</div>
						</div>
					)}
				</div>
			)}

			<div className="mt-8 flex items-center gap-4 md:hidden">
				<Button
					className="flex !h-10 flex-1 items-center justify-center gap-2 rounded-[6px] bg-neutral-200 font-inter !text-P6 font-semibold leading-160 text-neutral-1100 transition-all duration-500 hover:bg-neutral-200 hover:bg-opacity-40 disabled:cursor-not-allowed disabled:bg-transparent disabled:text-neutral-600"
					variant="secondary"
					onClick={handlePreviousLesson}
					disabled={!canNavigateToPreviousLesson()}
				>
					<ArrowLeftIcon width={18} height={18} />
					Aula anterior
				</Button>

				<Button
					className="flex !h-10 flex-1 items-center justify-center gap-2 rounded-[6px] bg-neutral-200 font-inter !text-P6 font-semibold leading-160 text-neutral-1100 transition-all duration-500 hover:bg-neutral-200 hover:bg-opacity-40 disabled:cursor-not-allowed disabled:bg-transparent disabled:text-neutral-600"
					onClick={handleNextLesson}
					disabled={!canNavigateToNextLesson()}
				>
					Próxima aula
					<ArrowRightIcon width={18} height={18} />
				</Button>
			</div>
		</>
	);
}
